module.exports = __webpack_public_path__ + "static/media/fruits_44.28cc9774.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_44.csv
// module id = 711
// module chunks = 0